import moment from "moment"
class files{
    constructor( requestId, docId, coment, date, files) { 
    this.requestId = requestId
    this.docId = docId
    this.coment=coment
    this.date = moment.utc(date).format('DD-MM-YYYY')
    this.files=files
    }
    static fromJson({ 
        solicitudId,
        docId,
        comentario,
        fecha,
        archivo }) {
      return new files(
        solicitudId,
        docId,
        comentario,
        fecha,
        archivo
        );
    }
  }
  export default files